import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { map, take } from 'rxjs';

/**
 * Guard that checks if a content creator's profile is complete
 * If the profile is incomplete, redirects to the profile completion page
 */
export const profileCompletionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userService = inject(UserService);

  return userService.isCreatorWithIncompleteProfile().pipe(
    take(1),
    map(isIncomplete => {
      // If the user is a content creator with an incomplete profile
      if (isIncomplete) {
        // Don't redirect if already on the profile completion page
        if (state.url === '/account/creator-profile') {
          return true;
        }

        // Return a UrlTree to let the router handle the redirect without double navigation
        return router.parseUrl('/account/creator-profile');
      }

      // Allow access if not a content creator or profile is complete
      return true;
    })
  );
};
